import React from "react";
import BubbleWhatsappButton from "../bubbleWhatsappButton/BubbleWhatsappButton";
import BubblePhoneButton from "../bubblePhoneButton/BubblePhoneButton";
import { smsIcon } from "../../utils/historyIcons/historyIcons";
import {
  IsAllow,
  ValidatePermission,
} from "../../utils/allowHelper/AllowHelper";
import { PERMISSION_CODE } from "../../utils/enum/enums";

const PhoneStepSelector = ({ allow, customer, onSelect, user }) => (
  <div className="flex justify-around gap-4">
    {IsAllow(allow, "call") && (
      <BubblePhoneButton
        customer={customer}
        disabled={!ValidatePermission(user, [PERMISSION_CODE.DO_CALLS])}
      />
    )}
    {IsAllow(allow, "whatsapp") && (
      <BubbleWhatsappButton
        customer={customer}
        handleNextStep={() => onSelect("whatsapp")}
      />
    )}
    {IsAllow(allow, "msg") && (
      <button
        onClick={() => onSelect("sms")}
        className={
          "max-w-sm p-4 text-gray-700 hover:text-blue-600" +
          !ValidatePermission(user, [PERMISSION_CODE.SEND_SMS])
            ? "opacity-100 cursor-pointer"
            : "opacity-50 cursor-not-allowed"
        }
        disabled={ValidatePermission(user, [PERMISSION_CODE.SEND_SMS])}
      >
        {smsIcon(40, 40)}
      </button>
    )}
  </div>
);

export default PhoneStepSelector;
